import React from 'react'

import * as styles from './index.module.css'
import { GradientBorder } from '../commons'
import { GatsbyImage } from 'gatsby-plugin-image'

const SensorUpdateProcess = ({
  title,
  components,
  subtitle,
  images,
  container,
}) => {
  const frags = subtitle.subtitle.split('\n')
  return (
    <div className="wrapper">
      <div className={!container && styles.container}>
        <GradientBorder height="1px" className={styles.gradBorder} />
        <h2>{title}</h2>
        <div className={styles.subtext}>{frags[0]}</div>
        <ol className="steps">
          {frags.slice(1).map((step, idx) => (
            <li
              key={idx}
              className={styles.step}
              dangerouslySetInnerHTML={{ __html: `<p>${step}</p>` }}
            />
          ))}
        </ol>
        <div className={styles.frontImageContainer}>
          <GatsbyImage
            image={images[0].gatsbyImageData}
            className={styles.frontImage}
            alt={images[0]?.description}
          />
        </div>
      </div>
    </div>
  )
}

export default SensorUpdateProcess
